import { ConfirmDialogProps } from 'components/Dialog/ConfirmDialog'

export interface IConfirmDialogState
    extends Omit<ConfirmDialogProps, 'children' | 'onSave' | 'onDiscard'> {
    message: string | React.ReactNode
    isWarning?: boolean
    callback?: (v: boolean) => Promise<void> | void
}
const DEFAULT_CONFIRM_TEXT = 'button.confirm'
const DEFAULT_CANCEL_TEXT = 'button.discard'

const defaultState: IConfirmDialogState = {
    open: false,
    message: '',
    title: 'Confirmation',
    discardBtnText: DEFAULT_CANCEL_TEXT,
    confirmText: DEFAULT_CONFIRM_TEXT,
    hideConfirmBtn: false,
    hideCancelBtn: false,
    confirmColor: undefined,
    isWarning: false,
    discardColor: undefined,
}

export const CONFIRM_DIALOG_SHOW = 'CONFIRM_DIALOG_SHOW'

export default function reducer(
    state: IConfirmDialogState = defaultState,
    action:
        | {
              type: 'CONFIRM_DIALOG_SHOW'
              payload: Omit<IConfirmDialogState, 'open'>
          }
        | {
              type: 'CLOSE_DIALOG'
          },
): IConfirmDialogState {
    switch (action.type) {
        case CONFIRM_DIALOG_SHOW:
            if (state.open) return state

            const { message, title, callback, ...props } = action.payload
            return {
                ...defaultState,
                ...props,
                open: true,
                message,
                title: title || defaultState.title,
                callback,
            }
        case 'CLOSE_DIALOG':
            return {
                ...defaultState,
            }
        default:
            return state
    }
}
